<app-new-student *ngIf="showNewStudentDialog" [parentGuardianDetails]="parentGuardianDetails"
  [showDialog]="showNewStudentDialog" [student]="currentStudent" [type]="type"
  (hideDialog)="showNewStudentDialog = false"></app-new-student>

<kendo-dialog title="Student Search" *ngIf="showSearchModal" (close)="onHideHandler()" maxHeight="85vh" width="80vw"
  [minHeight]="300" [animation]="{ duration: 300, type: 'fade', direction: 'down' }"
  autoFocusedElement=".first-focusable, .k-dialog-content input:not([disabled]), .k-dialog-content select:not([disabled])">
  <kendo-loader type="converging-spinner" size="large" *ngIf="loading" class="loader"></kendo-loader>

  <div class="search-instructions emptySearchMsg form-error" *ngIf="!showCreateLinkStudent">
    Please enter either a valid Student ID or the Student Name to proceed.
  </div>

  <div class="search-instructions" [ngClass]="{ 'form-error': emptyStudentLink }" *ngIf="showCreateLinkStudent">
    Please enter valid Student Name to proceed.
  </div>

  <form [formGroup]="searchFormGroup">
    <div class="search-form">
      <kendo-formfield class="flex-element" *ngIf="!showCreateLinkStudent">
        <kendo-floatinglabel text="Student ID">
          <kendo-numerictextbox format="##" #nycid id="nycidInput" size="large" [maxlength]="9" rounded="large"
            formControlName="nycid" [spinners]="false">
          </kendo-numerictextbox>
        </kendo-floatinglabel>
        <kendo-formhint>Student ID should be 6, 7 or 9 digits</kendo-formhint>
        <kendo-formerror *ngIf="searchFormGroup.get('nycid').errors?.invalidNycid">
          Student ID should be 6, 7 or 9 digits
        </kendo-formerror>
      </kendo-formfield>
      <div *ngIf="!showCreateLinkStudent" class="flex-element no-grow or-icon">
        &nbsp;
      </div>
      <kendo-formfield [ngClass]="
          showCreateLinkStudent === true
            ? 'student-link-flex-element'
            : 'flex-element'
        ">
        <kendo-floatinglabel text="First Name">
          <kendo-textbox [readonly]="showCreateLinkStudent" #firstName size="large" id="studentFirstName" (keypress)="restrictNumbers($event)" rounded="large"
            formControlName="firstName">
          </kendo-textbox>
        </kendo-floatinglabel>
        <kendo-formerror>
          {{ searchFormGroup.get("firstName")?.errors?.validateName?.message }}
        </kendo-formerror>
      </kendo-formfield>

      <kendo-formfield class="flex-element">
        <kendo-floatinglabel text="Last Name">
          <kendo-textbox [readonly]="showCreateLinkStudent" #lastName size="large" rounded="large" (keypress)="restrictNumbers($event)"
            formControlName="lastName">
          </kendo-textbox>
        </kendo-floatinglabel>
        <kendo-formerror>
          {{ searchFormGroup.get("lastName")?.errors?.validateName?.message }}
        </kendo-formerror>
      </kendo-formfield>

      <kendo-formfield *ngIf="showCreateLinkStudent">
        <kendo-label [for]="dob" text="DOB"></kendo-label>
          <kendo-datepicker [readonly]="true" calendarType="classic" #dob formControlName="dob" rounded="large" [size]="'large'"
            [formatPlaceholder]="formatPlaceholder" [min]="minDOB" [max]="maxDOB">
          </kendo-datepicker>
        <kendo-formerror *ngIf="searchFormGroup.get('dob')?.hasError('required')">
          Date of Birth is required.
        </kendo-formerror>

      </kendo-formfield>

      <button kendoButton class="search-btn" themeColor="primary" type="button" rounded="large" fillMode="solid"
        (click)="studentSearch()" [disabled]="
          searchFormGroup.get('firstName')?.invalid ||
          searchFormGroup.get('lastName')?.invalid ||
          searchFormGroup.get('nycid')?.invalid ||
          searchFormGroup.get('dob')?.invalid
        ">
        Search
      </button>
    </div>
  </form>

  <div [hidden]="!showResults" aria-live="assertive">
    <p>
      Please review the following students from the general education and
      special education database and select the name that matches the student
      being referred.
    </p>

    <div class="loading-container" *ngIf="loadCreateLinkStudentSpinner">
      <kendo-loader type="converging-spinner" size="medium"></kendo-loader>
    </div>

    <kendo-grid #grid class="student-search-grid" [kendoGridBinding]="students" scrollable="scrollable"
      [pageSize]="pageSize" [pageable]="true" [sortable]="true" [groupable]="false" [resizable]="false"
      [columnMenu]="{ filter: true, columnChooser: false }" [loading]="loading" [selectable]="false"
      [navigable]="false" tabindex="-1"
      [sort]="[{ field: 'studentName', dir: 'asc' }]">
      <kendo-grid-column #grid field="" [sortable]="false" [width]="40" headerClass="action-column" title="Actions">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <button kendoButton #anchor [svgIcon]="actionIcon" fillMode="clear" size="none"
            [attr.aria-labelledby]="'student-action-label-' + rowIndex"
            (click)="openMenu(dataItem, rowIndex)">
            <span class="k-sr-only" [id]="'student-action-label-' + rowIndex">
              Actions button for student {{ dataItem.studentName }}
            </span>
          </button>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="studentName" title="Student" [width]="350" [columnMenu]="false">
        <ng-template kendoGridHeaderTemplate let-column>
          <span>{{ column.title }}</span>
          <kendo-grid-column-menu [column]="column" [settings]="{ filter: true, columnChooser: false }"
            [tabIndex]="'0'"></kendo-grid-column-menu>
        </ng-template>
        <ng-template kendoGridCellTemplate let-data>
          <div class="name-container">
            <div class="student-name k-text-ellipsis">
              {{ data.studentName }}
            </div>
          </div>
          <div class="student-id">{{ data.nycId ? data.nycId : data.eiId ? 'EI: ' + data.eiId : ''}}</div>
          <div class="name-container">
            <span *ngIf="data.atsStatus === dischargedStatusCode || data.atsStatus === discharged"
              class="k-chip k-chip-lg k-rounded-full k-chip-solid k-chip-warning k-selected status-chip closed-chip">
              ATS: Discharged
            </span>
            <span *ngIf="data.atsStatus === activeStatusCode || data.atsStatus === active"
              class="k-chip k-chip-lg k-rounded-full k-chip-outline k-chip-info k-selected status-chip">
              ATS: Active
            </span>
            <!-- Added for demo -->
            <span *ngIf="data.isActive"
              class="k-chip k-chip-lg k-rounded-full k-chip-solid k-chip-success k-selected status-chip active-chip">
              Special Education Status: Active
            </span>
            <span *ngIf="data.isActive === false || data.studentStatus === closed"
              class="k-chip k-chip-lg k-rounded-full k-chip-solid k-selected status-chip closed-chip gray-chip">
              <ng-container *ngIf="data.caseCloseDate">
                {{ data.isActive === false ? 'Special Education Status: Inactive (' + (data.caseCloseDate | date:
                'MM/dd/yyyy') + ')' :
                data.studentStatus === 'Closed' ? 'Special Education Status: Case Closed (' + (data.caseCloseDate |
                date:
                'MM/dd/yyyy') + ')' : '' }}
              </ng-container>
            </span>

            <span *ngIf="data.ineligibleSE"
              class="k-chip k-chip-lg k-rounded-full k-chip-solid k-chip-warning k-selected status-chip active-chip">
              Special Education Status: Ineligible
            </span>
          </div>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="dateOfBirthUnixTimestamp" title="DOB" [width]="100" [resizable]="false"
        [columnMenu]="false">
        <ng-template kendoGridHeaderTemplate let-column>
          <span>{{ column.title }}</span>
          <kendo-grid-column-menu [column]="column" [settings]="{ filter: true, columnChooser: false }"
            [tabIndex]="'0'"></kendo-grid-column-menu>
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          {{ dataItem.dateOfBirth }}
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="gender" title="Gender" [width]="100" [resizable]="false" [columnMenu]="false">
        <ng-template kendoGridHeaderTemplate let-column>
          <span>{{ column.title }}</span>
          <kendo-grid-column-menu [column]="column" [settings]="{ filter: true, columnChooser: false }"
            [tabIndex]="'0'"></kendo-grid-column-menu>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="grade" title="Grade" [width]="90" [resizable]="false" [columnMenu]="false">
        <ng-template kendoGridHeaderTemplate let-column>
          <span>{{ column.title }}</span>
          <kendo-grid-column-menu [column]="column" [settings]="{ filter: true, columnChooser: false }"
            [tabIndex]="'0'"></kendo-grid-column-menu>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="school" title="School" [width]="200" [columnMenu]="false">
        <ng-template kendoGridHeaderTemplate let-column>
          <span>{{ column.title }}</span>
          <kendo-grid-column-menu [column]="column" [settings]="{ filter: true, columnChooser: false }"
            [tabIndex]="'0'"></kendo-grid-column-menu>
        </ng-template>
      </kendo-grid-column>

      <ng-template kendoGridNoRecordsTemplate>
        <p>There is no data to display.</p>
      </ng-template>

      <ng-template kendoGridLoadingTemplate>
        <!-- TODO: this will need to be placed in its own component: a custom ATLAS loader component -->
        <!-- TODO: once the code below is in its own component we'll need to add `[hidden]=true` to: <div class="k-loading-panel">  -->
        <div class="k-loading-panel">
          <div class="k-loading-panel-mask"></div>
          <div class="k-loading-panel-wrapper">
            <!-- <kendo-loader type="converging-spinner" size="medium"></kendo-loader> -->
            <!-- TODO: do we also want to add the "Loading..." text? -->
          </div>
        </div>
      </ng-template>
    </kendo-grid>
    <kendo-contextmenu #gridmenu showOn="click" [items]="dataItem?.actions"
      (select)="onSelect($event)"></kendo-contextmenu>
  </div>
  <kendo-dialog-actions layout="end" *ngIf="showCreateStudentBtn">
    <button kendoButton themeColor="primary" type="button" rounded="large" fillMode="solid" [svgIcon]="svgPlus"
      *ngIf="showCreate && showResults" (click)="addNewStudent(false)">
      Create New Student
    </button>
  </kendo-dialog-actions>
</kendo-dialog>